<template>
	<div class='attestation-wrap'>
		<h2>信用修复</h2>
		<div class="right-tips">
			您提供的证件、信息等内容必须真实、准确、完整、及时、有效，如若因您提供的证件、信息等内容不满足真实、准确、完整、及时、有效条件而引致的各种损失或责任，均由您本人承担！！！
		</div>
		<div class="attestation-tips">请填写或提供以下信息材料，便于后台人员审核。</div>
		<el-form ref="form" :model="formData" label-width="200px" label-position="right" :rules="rules">
			<el-form-item label="主体类型" prop="type">
				<el-select v-model="formData.type" placeholder="">
					<el-option label="法人" value="法人"></el-option>
					<el-option label="自然人" value="自然人"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item prop="name" label="主体名称">
				<el-input v-model="formData.name" placeholder=""></el-input>
			</el-form-item>
			<el-form-item prop="number" label="统一社会信用代码/身份证号">
				<el-input v-model="formData.number" placeholder=""></el-input>
			</el-form-item>

			<el-form-item prop="description" label="描述">
				<el-input type="textarea" v-model="formData.description" placeholder="" rows="5" resize="none"></el-input>
			</el-form-item>
			<el-form-item label="修复类型" prop="appealtype">
				<el-select v-model="formData.appealtype" placeholder="">
					<el-option v-for="item in appealTypeList" :key="item.id" :label="item.label" :value="item.id"></el-option>
				</el-select>
			</el-form-item>

			<el-form-item prop="mobile" label="联系电话">
				<el-input v-model="formData.mobile" placeholder="" maxlength="11" type="number"></el-input>
			</el-form-item>

			<el-form-item label="失信行为" prop="acttype">
				<el-select v-model="formData.acttype" placeholder="" @change="actTypeChange">
					<el-option label="一般失信行为" :value="1"></el-option>
					<el-option label="严重失信行为" :value="2"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="修复方式" prop="repairmethod" v-if="!!formData.acttype">
				<el-select v-model="formData.repairmethod" placeholder="">
					<el-option label="方式1" :value="1" :disabled="formData.acttype===2"></el-option>
					<el-option label="方式2" :value="2" :disabled="formData.acttype===2"></el-option>
					<el-option label="方式3" :value="3" :disabled="formData.acttype===1"></el-option>
				</el-select>
			</el-form-item>

			<el-form-item prop="file1" label="材料一" required :show-message="false" v-if="[1,2,3].includes(formData.repairmethod)">
				<el-upload class="upload-demo" :action="action" :on-preview="(file)=>handlePreview(file,1)" :before-upload="(file)=>beforeUpload(file,1)"
					:on-success="(response, file, fileList)=>onSuccess(response, file, fileList, 1)" :on-error="(file)=>onError(file,1)"
					:on-remove="(file, fileList)=>handleRemove(file, fileList,1)" :file-list="fileList1" list-type="text" accept=".doc, .docx, .pdf, .xls, .xlsx, .png, .jpg">
					<el-button size="mini" type="primary">上传</el-button>
				</el-upload>
			</el-form-item>
			<el-form-item prop="file2" label="材料二" required :show-message="false" v-if="[1,3].includes(formData.repairmethod)">
				<el-upload class="upload-demo" :action="action" :on-preview="(file)=>handlePreview(file,2)" :before-upload="(file)=>beforeUpload(file,2)"
					:on-success="(response, file, fileList)=>onSuccess(response, file, fileList, 2)" :on-error="(file)=>onError(file,2)"
					:on-remove="(file, fileList)=>handleRemove(file, fileList,2)" :file-list="fileList2" list-type="text" accept=".doc, .docx, .pdf, .xls, .xlsx, .png, .jpg">
					<el-button size="mini" type="primary">上传</el-button>
				</el-upload>
			</el-form-item>
			<el-form-item prop="file3" label="材料三" required :show-message="false" v-if="[1,3].includes(formData.repairmethod)">
				<el-upload class="upload-demo" :action="action" :on-preview="(file)=>handlePreview(file,3)" :before-upload="(file)=>beforeUpload(file,3)"
					:on-success="(response, file, fileList)=>onSuccess(response, file, fileList, 3)" :on-error="(file)=>onError(file,3)"
					:on-remove="(file, fileList)=>handleRemove(file, fileList,3)" :file-list="fileList3" list-type="text" accept=".doc, .docx, .pdf, .xls, .xlsx, .png, .jpg">
					<el-button size="mini" type="primary">上传</el-button>
				</el-upload>
			</el-form-item>
			<el-form-item prop="file4" label="材料四" required :show-message="false" v-if="[2].includes(formData.repairmethod)">
				<el-upload class="upload-demo" :action="action" :on-preview="(file)=>handlePreview(file,4)" :before-upload="(file)=>beforeUpload(file,4)"
					:on-success="(response, file, fileList)=>onSuccess(response, file, fileList, 4)" :on-error="(file)=>onError(file,4)"
					:on-remove="(file, fileList)=>handleRemove(file, fileList,4)" :file-list="fileList4" list-type="text" accept=".doc, .docx, .pdf, .xls, .xlsx, .png, .jpg">
					<el-button size="mini" type="primary">上传</el-button>
				</el-upload>
			</el-form-item>
			<el-form-item prop="file5" label="材料五" required :show-message="false" v-if="[3].includes(formData.repairmethod)">
				<el-upload class="upload-demo" :action="action" :on-preview="(file)=>handlePreview(file,5)" :before-upload="(file)=>beforeUpload(file,5)"
					:on-success="(response, file, fileList)=>onSuccess(response, file, fileList, 5)" :on-error="(file)=>onError(file,5)"
					:on-remove="(file, fileList)=>handleRemove(file, fileList,5)" :file-list="fileList5" list-type="text" accept=".doc, .docx, .pdf, .xls, .xlsx, .png, .jpg">
					<el-button size="mini" type="primary">上传</el-button>
				</el-upload>
			</el-form-item>
			<el-form-item prop="file6" label="材料六" required :show-message="false" v-if="[3].includes(formData.repairmethod)">
				<el-upload class="upload-demo" :action="action" :on-preview="(file)=>handlePreview(file,6)" :before-upload="(file)=>beforeUpload(file,6)"
					:on-success="(response, file, fileList)=>onSuccess(response, file, fileList, 6)" :on-error="(file)=>onError(file,6)"
					:on-remove="(file, fileList)=>handleRemove(file, fileList,6)" :file-list="fileList6" list-type="text" accept=".doc, .docx, .pdf, .xls, .xlsx, .png, .jpg">
					<el-button size="mini" type="primary">上传</el-button>
				</el-upload>
			</el-form-item>
			<el-form-item label="">
				<el-button type="primary" @click="confirmHandle">提交</el-button>
				<el-button type="warning" @click="reset">取消</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
import BASE_URL from '@/api/base.js'

import { creditRepairs } from '@/api';
export default {
	components: {},
	data() {
		return {
			action: BASE_URL + '/api/file/upload',
			appealTypeList: [
				// { id: 0, label: '信息概览' },
				// { id: 1, label: '行政许可' },
				{ id: 2, label: '行政处罚' },
				// { id: 3, label: '守信红名单' },
				{ id: 4, label: '失信黑名单' },
				{ id: 5, label: '企业经营异常名录' },
			],
			formData: {},
			rules: {
				type: [{ required: true, message: '请选择主体类型' }],
				name: [{ required: true, message: '请填写主体名称' }],
				description: [{ required: true, message: '请填写描述' }],
				number: [{ required: true, message: '请填写统一社会信用代码/身份证号' }],
				appealtype: [{ required: true, message: '请选择修复类型' }],
				mobile: [{ required: true, message: '请填写联系电话' }],
				acttype: [{ required: true, message: '请选择失信行为' }],
				repairmethod: [{ required: true, message: '请选择修复方式' }]
			},
			fileList1: [],
			fileList2: [],
			fileList3: [],
			fileList4: [],
			fileList5: [],
			fileList6: [],
		}
	},
	created() { },
	mounted() {
		const { query } = this.$route;
		const { name, number, appealtype, dataId } = query;
		console.log(appealtype, number, dataId);
		this.$set(this, 'formData', Object.assign({}, this.formData, {
			number,
			appealtype: +appealtype,
			name: name || '',
            dataid: dataId
		}))
	},
	methods: {
		// 失信行为change事件
		actTypeChange(e) {
			console.log(e);
			if (e === 1) {
				this.$set(this.formData, 'repairmethod', 1);
			} else {
				this.$set(this.formData, 'repairmethod', 3);
			}
		},
		handleRemove(file, fileList, type) {
			console.log(file, fileList);
		},
		handlePreview(file, type) {
			console.log(file);
		},
		beforeUpload(file, type) {

		},
		onSuccess(response, file, fileList, type) {
			const { name } = file;
			const { result } = response;
			const files = this.formData[`file${type}`];
			this.$set(this.formData, `file${type}`, Object.assign({}, files, { url: result, name }))
			console.log(this.formData);
		},
		onError() { },
		handleRemove2(file, fileList) {
			console.log(file, fileList);
		},

		testFile(file, typeName) {
			if (!file.url) {
				return this.$message({
					message: `请上传材料${typeName}`,
					type: 'warning'
				});
			}
			return true
		},

		confirmHandle() {

			this.$refs['form'].validate((valid) => {
				if (valid) {

					const { dataid, acttype, repairmethod, type, name, number, description, appealtype, mobile, ...formData } = this.formData;
					const fileParams = {
						acttype, repairmethod, type, name, number, description, appealtype, mobile, dataid
					};
					if (+repairmethod === 2) {
						const { file1, file4 } = this.formData;

						this.testFile(file1, '一');
						this.testFile(file4, '四');

						fileParams.file1 = Object.assign({}, file1,)
						fileParams.file4 = Object.assign({}, file4,)

					} else {
						const { file1, file2, file3, name1, name2, name3 } = this.formData;
						this.testFile(file1, name1, '一');
						this.testFile(file2, name2, '二');
						this.testFile(file3, name3, '三');

						fileParams.file1 = Object.assign({}, file1,)
						fileParams.file2 = Object.assign({}, file2,)
						fileParams.file3 = Object.assign({}, file3,)
						if (+repairmethod === 3) {
							const { file5, file6 } = this.formData;

							this.testFile(file5, '五');
							this.testFile(file6, '六');

							fileParams.file5 = Object.assign({}, file5,)
							fileParams.file6 = Object.assign({}, file6,)
						}
					}

					creditRepairs(fileParams).then(res => {
						this.$message({
							message: '提交成功，请等待审核',
							type: 'success'
						});
						this.reset();
					})
				}
			})
		},
		reset() {
			this.$refs['form'].resetFields();
			this.$set(this, 'formData', {});
			this.$set(this, 'fileList', []);
			this.$set(this, 'fileList2', []);
			this.$set(this, 'fileList3', []);
		}
	},
	computed: {},
	watch: {},
}
</script>
<style lang='scss' >
	.attestation-wrap {
		padding: 22px 18px;
		text-align: left;
		position: relative;
		.right-tips {
			position: absolute;
			top: 40px;
			right: 0;
			width: 250px;
			line-height: 28px;
			padding: 0 0 0 21px;
			color: $red;
			border-left: 2px solid $red;
		}
		& > h2 {
			color: $red;
		}
		& > .attestation-tips {
			margin: 35px 0 20px;
			text-align: center;
			color: #686868;
		}
		.el-input {
			height: 40px;
			.el-input__inner {
				height: 40px;
				border-radius: 3px;
				border: 1px solid #e3d7ea;
			}
		}
		.el-textarea {
			width: 500px;
		}
		.code-tips {
			color: #686868;
			margin-bottom: 10px;
		}

		.el-button {
			width: 100px;
			margin: 50px 20px 0;
			&:not(.el-button--warning) {
				background-color: $red;
				border-color: $red;
			}
		}

		.el-upload {
			.el-button {
				margin: 0 0;
			}
		}

		.el-upload-list__item {
			width: 500px;
		}
	}
</style>